module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal-fade"
    },
    on: {
      "after-leave": _vm.afterLeave
    }
  }, [_c('div', {
    staticClass: "widget",
    on: {
      "click": _vm.closeModal
    }
  }, [(_vm.modalType !== 'modal') ? _c('button', {
    staticClass: "btn-ghost"
  }, [_vm._v("退出预览")]) : _vm._e(), _vm._v(" "), (_vm.modalType === 'app') ? _c('div', {
    staticClass: "modal"
  }, [_c('img', {
    staticClass: "preview-img",
    attrs: {
      "src": "/static/launchPreview/phone.png",
      "alt": "img"
    },
    on: {
      "click": _vm.prevent
    }
  })]) : (_vm.modalType === 'wap') ? _c('div', {
    staticClass: "modal"
  }, [_c('img', {
    staticClass: "preview-img",
    attrs: {
      "src": "/static/launchPreview/phone.png",
      "alt": "img"
    },
    on: {
      "click": _vm.prevent
    }
  }), _vm._v(" "), _c('iframe', {
    attrs: {
      "src": _vm.preUrl,
      "frameborder": "0",
      "width": "240",
      "height": "440"
    }
  })], 1) : _c('div', {
    staticClass: "modal",
    on: {
      "click": _vm.prevent
    }
  }, [_c('div', {
    staticClass: "modal-head"
  }, [_vm._v(_vm._s(_vm.head))]), _vm._v(" "), _c('div', {
    staticClass: "modal-body clearfix"
  }, [_vm._t("custom"), _vm._v(" "), _vm._t("launchTemp")], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer clearfix"
  }, [(_vm.modalType !== 'alertTip') ? _c('button', {
    staticClass: "modal-btn modal-btn-sub",
    on: {
      "click": _vm.subEvent
    }
  }, [_vm._v(_vm._s(_vm.subText))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "modal-btn",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(_vm._s(_vm.cancelText))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-82a487bc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widget/modal/modal.vue
// module id = 449
// module chunks = 2